// extracted by mini-css-extract-plugin
module.exports = {"disclaimer":"landing-page-module--disclaimer--19C-4"};